import { Card } from 'antd'

import { useState } from 'react'
import ListCV from './ListCV'

type Props = { activeTab?: string }
export const ApplicationContainer = ({ activeTab }: Props) => {
  const [isAddNew, setIsAddNew] = useState(false)
  return (
    <>
      <Card>
        <ListCV onAddNew={() => setIsAddNew(true)} />
      </Card>
    </>
  )
}
